export enum MaterialColumnsEnum {
  Date = 'date',
  Name = 'description',
  Description = 'description2',
  Number = 'number',
  Quantity = 'quantity',
  Unit = 'unit',
  Price = 'price',
  Total = 'Total',
  Note = 'note',
  FirstName = 'person.firstName',
  LastName = 'person.lastName',
  PersonalNR = 'person.number',
}
